import { Unstable_Grid2 as Grid, Typography } from "@mui/material";

/**
 * @deprecated use SenecLabelContent instead
 */
export const BasicLabelDataPoint = ({ label, content }: { label: string; content: string }) => {
    return (
        <Grid sx={{ marginBottom: "1rem" }} data-testid="label-content-pt" key={label} xs={6}>
            <Typography data-testid={"label-id"} variant={"body1"}>
                {label}
            </Typography>
            <Typography
                data-testid={"content-id"}
                sx={{
                    fontWeight: 700,
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                }}
                style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                }}
            >
                {content}
            </Typography>
        </Grid>
    );
};
